import React from 'react';

import styles from './researchPerformanceStyles';

import Table from 'buyside/components/presentation/Table/table';
import Button from 'buyside/components/presentation/Button/button';

import { userIdeaUrl } from 'buyside/util/urlHelper';

const ResearchPerformance = ({ userProfile }) => {
  const {
    ideaTotalReturnAverage,
    ideaReturnVsBenchmarkAverage,
    ideaAnnualizedReturnMedian,
    user
  } = userProfile;
  const items = [
    { label: 'Total Return (Avg.)', value: ideaTotalReturnAverage },
    {
      label: 'Return vs. Benchmark (Avg.)',
      value: ideaReturnVsBenchmarkAverage
    },
    { label: 'Annualized Return (Median)', value: ideaAnnualizedReturnMedian }
  ].filter(item => item.value);
  return (
    <div>
      <div className={styles.researchPerformanceTable}>
        <Table
          headings={['Metric', 'Idea Performance']}
          items={items}
          getItemAttrs={item => [item.label, item.value]}
          // rowClassName={styles.rankingsTableRow}
        />
      </div>
      {/* <ul className={styles.researchPerformanceList}>
        {items.map((item, idx) => (
          <li key={idx}>
            <h4>{item.label}</h4>
            <span>{item.value}</span>
          </li>
        ))}
      </ul> */}
      <Button text="View all of this member's Ideas" url={userIdeaUrl(user.id)} />
    </div>
  );
};

export default ResearchPerformance;
